import * as React from 'react'

import Svg, { G, Path, Defs, ClipPath } from 'react-native-svg'

import { IconProps } from '../icons'

const ActivityOutlined = ({
  size = 24,
  color = '#000',
  ...props
}: IconProps) => (
  <Svg
    width={`${size}px`}
    height={`${size}px`}
    viewBox="0 0 24 24"
    fill="none"
    {...props}
  >
    <G clipPath="url(#a)">
      <Path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M21 5.09a2.33 2.33 0 1 1-4.66 0 2.33 2.33 0 0 1 4.66 0ZM8.82 4.51c-2.322 0-4.26 1.955-4.26 4.37v6.22c0 2.415 1.938 4.37 4.26 4.37h6.3c2.322 0 4.26-1.955 4.26-4.37v-4.95a.8.8 0 0 1 1.6 0v4.95c0 3.266-2.622 5.97-5.86 5.97h-6.3c-3.238 0-5.86-2.704-5.86-5.97V8.88c0-3.265 2.622-5.97 5.86-5.97h5.06a.8.8 0 0 1 0 1.6H8.82Zm2.198 2.113a.8.8 0 0 1 .702.58l1.96 6.933.98-2.38a.8.8 0 0 1 .726-.496l1.76-.03a.8.8 0 0 1 .028 1.6l-1.234.02-1.66 4.034a.8.8 0 0 1-1.51-.086L10.758 9.68l-1.296 2.715a.8.8 0 0 1-.722.455H6.81a.8.8 0 0 1 0-1.6h1.425l1.993-4.175a.8.8 0 0 1 .79-.452Z"
        fill={color}
      />
    </G>
    <Defs>
      <ClipPath id="a">
        <Path fill="#fff" d="M0 0h24v24H0z" />
      </ClipPath>
    </Defs>
  </Svg>
)

export default ActivityOutlined
